var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['layout-wrapper-wrap', `layout-wrapper-${_vm.type}`]},[_c('div',{staticClass:"container"},[(_vm.card)?_c('a-card',_vm._g(_vm._b({class:_vm.cardClassName,attrs:{"bordered":_vm.bordered}},'a-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }